import { Button, Table, Input, Row, Col, Radio, Typography, Select, Space, message, Card } from "antd";
import {ExportOutlined, ReloadOutlined, SearchOutlined } from "@ant-design/icons";
import Highlighter from 'react-highlight-words';
import { useEffect, useRef, useState, } from "react";
import api from "../../API";
import * as XLSX from 'xlsx';
import dayjs from 'dayjs';
const options = [
  {
    value: 'ready',
    label: 'Ready'
  },
  {
    value: 'sent',
    label: 'Sent'
  },
  {
    value: 'deliveried',
    label: 'Deliveried'
  },
  {
    value: 'fail',
    label: 'Fail'
  }
]

function MessageLog() {
  const user = JSON.parse(localStorage.getItem('user'));
  const [loading, setLoading] = useState(false);
  const [dataSource, setDataSource] = useState([]);
  const [OAIdOptions, setOAIdOptions] = useState([]);
  const [tplType, settplType] = useState('All');
  const [OAId, setOAId] = useState(null);
  const [status, setStatus] = useState(null);
  const [searchText, setSearchText] = useState('');
  const originalMessages = useRef([]);
  const columns = [
    {
      title: "ID",
      dataIndex: "key",
      render: (text) =>
        searchText ? (
          <Highlighter
            highlightStyle={{
              backgroundColor: '#ffc069',
              padding: 0,
            }}
            searchWords={[searchText]}
            autoEscape
            textToHighlight={text ? text.toString() : ''}
          />
        ) : (
          text
        )
    },
    // {
    //   title: "Campaign",
    //   dataIndex: "campaignName",
    //   render: (text) =>
    //     searchText ? (
    //       <Highlighter
    //         highlightStyle={{
    //           backgroundColor: '#ffc069',
    //           padding: 0,
    //         }}
    //         searchWords={[searchText]}
    //         autoEscape
    //         textToHighlight={text ? text.toString() : ''}
    //       />
    //     ) : (
    //       text
    //     )
    // },
    {
      title: "Message Type",
      dataIndex: "messageType",
      render: (text) =>
        searchText ? (
          <Highlighter
            highlightStyle={{
              backgroundColor: '#ffc069',
              padding: 0,
            }}
            searchWords={[searchText]}
            autoEscape
            textToHighlight={text ? text.toString() : ''}
          />
        ) : (
          text
        )
    },
    {
      title: "ZaloUID",
      dataIndex: "zaloUid",
      render: (text) =>
        searchText ? (
          <Highlighter
            highlightStyle={{
              backgroundColor: '#ffc069',
              padding: 0,
            }}
            searchWords={[searchText]}
            autoEscape
            textToHighlight={text ? text.toString() : ''}
          />
        ) : (
          text
        )
    },
    {
      title: "Group ID",
      dataIndex: "zaloGid",
      render: (text) =>
        searchText ? (
          <Highlighter
            highlightStyle={{
              backgroundColor: '#ffc069',
              padding: 0,
            }}
            searchWords={[searchText]}
            autoEscape
            textToHighlight={text ? text.toString() : ''}
          />
        ) : (
          text
        )
    },
    // {
    //   title: "Phone Number",
    //   dataIndex: "phoneNumber",
    //   render: (text) =>
    //     searchText ? (
    //       <Highlighter
    //         highlightStyle={{
    //           backgroundColor: '#ffc069',
    //           padding: 0,
    //         }}
    //         searchWords={[searchText]}
    //         autoEscape
    //         textToHighlight={text ? text.toString() : ''}
    //       />
    //     ) : (
    //       text
    //     )
    // },
    {
      title: "Insert At",
      dataIndex: "insertAt",
      render: (text) =>
        searchText ? (
          <Highlighter
            highlightStyle={{
              backgroundColor: '#ffc069',
              padding: 0,
            }}
            searchWords={[searchText]}
            autoEscape
            textToHighlight={text ? text.toString() : ''}
          />
        ) : (
          text
        )
    },
    {
      title: "Read At",
      dataIndex: "readAt",
      render: (text) =>
        searchText ? (
          <Highlighter
            highlightStyle={{
              backgroundColor: '#ffc069',
              padding: 0,
            }}
            searchWords={[searchText]}
            autoEscape
            textToHighlight={text ? text.toString() : ''}
          />
        ) : (
          text
        )
    },
    {
      title: "Sent At",
      dataIndex: "sentAt",
      render: (text) =>
        searchText ? (
          <Highlighter
            highlightStyle={{
              backgroundColor: '#ffc069',
              padding: 0,
            }}
            searchWords={[searchText]}
            autoEscape
            textToHighlight={text ? text.toString() : ''}
          />
        ) : (
          text
        )
    },
    {
      title: "Status",
      dataIndex: "status",
      render: (text) =>
        searchText ? (
          <Highlighter
            highlightStyle={{
              backgroundColor: '#ffc069',
              padding: 0,
            }}
            searchWords={[searchText]}
            autoEscape
            textToHighlight={text ? text.toString() : ''}
          />
        ) : (
          text
        )
    },
    {
      title: "Status Reason",
      dataIndex: "statusReason",
      render: (text) =>
        searchText ? (
          <Highlighter
            highlightStyle={{
              backgroundColor: '#ffc069',
              padding: 0,
            }}
            searchWords={[searchText]}
            autoEscape
            textToHighlight={text ? text.toString() : ''}
          />
        ) : (
          text
        )
    },
    {
      title: "External Msg ID",
      dataIndex: "externalMsgId",
      render: (text) =>
        searchText ? (
          <Highlighter
            highlightStyle={{
              backgroundColor: '#ffc069',
              padding: 0,
            }}
            searchWords={[searchText]}
            autoEscape
            textToHighlight={text ? text.toString() : ''}
          />
        ) : (
          text
        )
    },
  ];

  useEffect(() => {
    setLoading(true);
    Promise.all([
      api.list_oaaccounts_by_user(user?.userId, user?.parentId,["id", "accountName", "OAId"]),
      api.list_all_campaigns(user?.userId),
      api.list_all_messages(user?.userId)
    ])
    .then(([oaaccounts, campaigns, messages]) => {
      if(oaaccounts?.length) setOAIdOptions(oaaccounts.map(oaaccount => ({value: oaaccount.OAId, label: oaaccount.accountName})))
      if(messages?.length && campaigns?.length)
      originalMessages.current = messages.map(msgObj => {
        var cmpObj = campaigns.find(campaign => campaign.campaignId === msgObj.campaignId);
        let messageType = cmpObj?.template_type?.at(0).toUpperCase() + cmpObj?.template_type?.slice(1);
        if(messageType === 'Gmfconsultant') messageType = 'Consultant';
        return ({
          //Cột nào ko được tìm kiếm bằng từ khóa
          OAId: msgObj.OAId,
          // Các cột sẽ được tìm kiếm bằng từ khóa
          key: msgObj.msgId,
          messageType,
          zaloUid: msgObj.zaloUid,
          zaloGid: msgObj.zaloGid,
          // campaignName: cmpObj?.campaignName,
          // phoneNumber: msgObj.phoneNumber,
          insertAt: dayjs(msgObj.insertAt).format("YYYY-MM-DD"),
          sentAt: msgObj.sentAt? dayjs(msgObj.sentAt).format("YYYY-MM-DD HH:mm:ss A"): '',
          status: msgObj.status,
          statusReason: msgObj.statusReason,
          readAt: msgObj.readAt,
          externalMsgId: msgObj.externalMsgId,
        })
      });
      setDataSource(originalMessages.current); 
    })
    .catch((error) =>  message.error(error.message))
    .finally(() => setLoading(false))
  },[])

  function handleFilterDataByRadioBtn(e) {
    let newMessages = originalMessages.current;
    if(e.target.value !== 'All') newMessages = newMessages.filter((value) => value.messageType === e.target.value);
    if(OAId) newMessages = newMessages.filter(value => value.OAId === OAId)
    if(status) {
      if(status === 'deliveried') newMessages = newMessages.filter((value) => value.status === 'sent' && value.statusReason === 'Success');
      else
      newMessages = newMessages.filter((value) => value.status === status);
    }
    if(searchText) newMessages = newMessages.filter((o) => Object.keys(o).slice(1).some((k) => o[k] && String(o[k])
      .toLowerCase()
      .includes(searchText.toLowerCase())));
    setLoading(true);
    settplType(e.target.value);
    setDataSource(newMessages);
    setLoading(false);
  }

  function handleOAId(selectedValue) {
    let newMessages = originalMessages.current;
    if(tplType !== 'All') newMessages = newMessages.filter((value) => value.messageType === tplType);
    if(selectedValue) newMessages = newMessages.filter(value => value.OAId === selectedValue);
    if(status) {
      if(status === 'deliveried') newMessages = newMessages.filter((value) => value.status === 'sent' && value.statusReason === 'Success');
      else
      newMessages = newMessages.filter((value) => value.status === status);
    }
    if(searchText) newMessages = newMessages.filter((o) => Object.keys(o).slice(1).some((k) => o[k] && String(o[k])
      .toLowerCase()
      .includes(searchText.toLowerCase())));
    setLoading(true);
    setOAId(selectedValue)
    setDataSource(newMessages);
    setLoading(false);
  }

  function handleSelectedStatus(selectedValue) {
    let newMessages = originalMessages.current;
    if(tplType !== 'All') newMessages = newMessages.filter((value) => value.messageType === tplType);
    if(OAId) newMessages = newMessages.filter(value => value.OAId === OAId);
    if(selectedValue) {
      if(selectedValue === 'deliveried') newMessages = newMessages.filter((value) => value.status === 'sent' && value.statusReason === 'Success');
      else
      newMessages = newMessages.filter((value) => value.status === selectedValue);
    }
    if(searchText) newMessages = newMessages.filter((o) => Object.keys(o).slice(1).some((k) => o[k] && String(o[k])
      .toLowerCase()
      .includes(searchText.toLowerCase())));
    setLoading(true);
    setStatus(selectedValue)
    setDataSource(newMessages);
    setLoading(false);
  }

  function handleSearchInfo(e) {
    let newMessages = originalMessages.current;
    if(tplType !== 'All') newMessages = newMessages.filter((value) => value.messageType === tplType);
    if(OAId) newMessages = newMessages.filter(value => value.OAId === OAId);
    if(status) {
      if(status === 'deliveried') newMessages = newMessages.filter((value) => value.status === 'sent' && value.statusReason === 'Success');
      else
      newMessages = newMessages.filter((value) => value.status === status);
    }
    if(e.target.value) newMessages = newMessages.filter((o) => Object.keys(o).slice(1).some((k) => o[k] && String(o[k])
      .toLowerCase()
      .includes(e.target.value.toLowerCase())));
    setLoading(true);
    setSearchText(e.target.value)
    setDataSource(newMessages);
    setLoading(false);
  }

  async function handleReloadMessages() {
    try {
      setLoading(true);
      const [campaigns, messages] = await Promise.all([
        api.list_all_campaigns(user?.userId),
        api.list_all_messages(user?.userId)
      ]);
      originalMessages.current = messages.map(msgObj => {
        var cmpObj = campaigns.find(campaign => campaign.campaignId === msgObj.campaignId);
        let messageType = cmpObj?.template_type?.at(0).toUpperCase() + cmpObj?.template_type?.slice(1);
        if(messageType === 'Gmfconsultant') messageType = 'Consultant';
        return ({
          OAId: msgObj.OAId,
          key: msgObj.msgId,
          messageType,
          zaloUid: msgObj.zaloUid,
          zaloGid: msgObj.zaloGid,
          insertAt: dayjs(msgObj.insertAt).format("YYYY-MM-DD"),
          sentAt: msgObj.sentAt? dayjs(msgObj.sentAt).format("YYYY-MM-DD HH:mm:ss A"): '',
          status: msgObj.status,
          statusReason: msgObj.statusReason,
          readAt: msgObj.readAt,
          externalMsgId: msgObj.externalMsgId,
        })
      });
      settplType('All');
      setOAId(null);
      setStatus(null);
      setSearchText(null);
      setDataSource(originalMessages.current);  
    } catch (error) {
      message.error(error.message);
    } finally {
      setLoading(false)
    }
  }

  async function handleExportAsXlsx() {
    try {
      const data = [
        columns.map(column => column.title),
        ...dataSource.map(item => Object.keys(item).slice(1).map(k => item[k]? item[k]: '-'))
      ];
      const worksheet = XLSX.utils.aoa_to_sheet(data); // aoa = array of array
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'download');
  
      XLSX.writeFile(workbook, 'download.xlsx');
    } catch (error) {
      message.error(error.message);
    }
  }

  return (
    <Card 
        style={{height: '100%', margin: "0 auto", boxShadow: "1px 1px 5px #ccc", borderRadius: 10 }}
        title={
          <Typography.Title level={5} style={{margin: 0}}>Messages Log</Typography.Title>
        }
        loading={loading}
        extra={
          <Space align="center" wrap>
            <Button 
              type="primary" 
              shape="circle"
              icon={<ReloadOutlined />}
              style={{padding:15}}
              onClick={handleReloadMessages}
              ></Button>
            <Button 
              type="primary" 
              icon={<ExportOutlined />}
              style={{padding:15}}
              onClick={handleExportAsXlsx}
              >Export Excel</Button>
          </Space>
        }
    >
      <Row gutter={[16,16]}  align="middle">
        <Col span={24}>
          <Radio.Group defaultValue={0} value={tplType} onChange={handleFilterDataByRadioBtn}> 
            <Radio.Button value='All'>All</Radio.Button>
            <Radio.Button value='Consultant'>Consultant</Radio.Button>
            <Radio.Button value='Promotion'>Promotion</Radio.Button>
            <Radio.Button value='Transaction'>Transaction</Radio.Button>
          </Radio.Group>
        </Col>
      </Row>
      <Row gutter={[16,16]}  align="middle" style={{marginTop: 16}}>
        <Col xxl={8} xl={8} lg={8} md={24} sm={24} xs={24}>
            <Select 
              popupMatchSelectWidth={false}
              options={OAIdOptions}
              value={OAId}
              showSearch
              allowClear
              placeholder="Select OA Account"
              filterOption={(input, option) =>
                (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
              }
              onChange={handleOAId}
              style={{width:'100%'}}
            />
          </Col>
        <Col xxl={8} xl={8} lg={8} md={24} sm={24} xs={24}>
          <Select 
            style={{width:'100%'}}
            placeholder="Select search status"
            popupMatchSelectWidth={false}
            value={status}
            showSearch
            allowClear
            onChange={handleSelectedStatus}
            options={options}
          />
        </Col>
        <Col xxl={8} xl={8} lg={8} md={24} sm={24} xs={24}>
          <Input 
              placeholder="Input search text"
              allowClear
              value={searchText}
              onChange={handleSearchInfo}
              suffix={<SearchOutlined />}/>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <Table  
            bordered
            scroll={{x: 1000}}
            columns= {columns} 
            style={{marginTop: 16, width: '100%'}} 
            dataSource={dataSource}
            loading={loading}
            pagination={{
              position: ["bottomCenter"],
              showSizeChanger: false, // Disable page size changer
              pageSize: 10, 
              showTotal: () => `Total: ${dataSource.length} items`
            }}
          />
        </Col>
      </Row>
    </Card>
  )
}

export default MessageLog;